<template>
	<template v-if="loading">
		<div class="w-full lg:max-w-[600px] h-[422px] lg:h-[540px] flex flex-col items-center justify-center">
			<span class="w-6 h-6 border-[3px] border-l-neutral-400 rounded-full animate-spin" />
		</div>
	</template>
	<template v-else-if="designDisplayUrl(currentDisplayLayer)">
		<div class="relative w-full max-w-[603px] mx-auto z-0">
			<img :src="designDisplayUrl(currentDisplayLayer)" :alt="activeDesign.title" class="w-full object-contain z-0" />
			<ul
				v-if="currentDisplayLayerIndex !== 0"
				:class="[
					'!p-0 !m-0 absolute grid grid-cols-palette-space grid-rows-palette-space',
					'h-[var(--height)] max-h-[var(--maxHeight)] w-[var(--width)] max-w-[var(--maxWidth)]',
					'top-[var(--top)] left-[var(--left)] -translate-x-1/2',
					renderedGridConstraints.isHorizontal ? 'grid-flow-row-dense' : 'grid-flow-col-dense',
				]"
				:style="`--height: ${renderedGridConstraints.height}%; --maxHeight: ${renderedGridConstraints.maxHeight}px; --width: ${renderedGridConstraints.width}%; --maxWidth: ${renderedGridConstraints.maxWidth}px; --top: ${renderedGridConstraints.top}%; --left: ${renderedGridConstraints.left}%; --rows: ${renderedGridConstraints.rows}; --cols: ${renderedGridConstraints.cols};`"
			>
				<li
					v-for="(item, index) in renderedGridSpaces[currentDisplayLayerIndex]"
					:key="item.isEmpty ? `${index}-empty-${updateKey}` : `${index}-${item.title}-${updateKey}`"
					:class="[
						!renderedGridConstraints.isHorizontal &&
							(item.isHalfTin ? 'row-span-1 col-span-1' : 'row-span-2 col-span-1'),
						renderedGridConstraints.isHorizontal &&
							(item.isHalfTin ? 'col-span-1 row-span-1' : 'col-span-2 row-span-1'),
					]"
				>
					<pb-space :index="index" :space="item" :is-horizontal="renderedGridConstraints.isHorizontal" />
				</li>
			</ul>
		</div>
		<ul
			class="flex flex-nowrap !p-0.5 w-min border-swatch border-zinc-400 bg-zinc-50 rounded-full mx-auto overflow-hidden"
		>
			<li v-for="(layer, index) of renderedLayers" :key="`layer-${index}-${updateKey}`">
				<button
					type="button"
					@click="handleTypeSelect(layer, index)"
					:class="[
						'text-sm/[14px] font-medium whitespace-nowrap',
						'min-w-16 !py-2 !px-3 -m-[0.5px] rounded-full transition-all duration-200',
						'hover:!opacity-100 border-swatch border-solid',
						layer === currentDisplayLayer ? 'bg-white border-zinc-400 opacity-100' : 'opacity-50 border-transparent',
					]"
				>
					{{ layer }}
				</button>
			</li>
		</ul>
		<div v-if="itemsWithQuantity.length > 0" class="flex justify-center items-center !mt-4">
			<button type="button" @click="resetAll" class="text-xs underline">Reset Palette</button>
		</div>
	</template>
</template>
<script setup>
import { watch, ref, onMounted, nextTick } from 'vue'
import { storeToRefs } from 'pinia'

import { usePaletteBuilderStore } from '@stores'

const store = usePaletteBuilderStore()
const {
	currentDisplayLayer,
	currentDisplayLayerIndex,
	activeDesign,
	renderedLayers,
	designDisplayUrl,
	renderedGridConstraints,
	renderedGridSpaces,
	itemsWithQuantity,
} = storeToRefs(store)
const { updateShareHash, resetAll } = store

const updateKey = ref(0)
const loading = ref(true)

onMounted(() => {
	nextTick(() => (updateKey.value += 1))
	setTimeout(() => {
		loading.value = false
	}, 500)
})

watch([activeDesign, itemsWithQuantity], () => {
	updateShareHash()
	updateKey.value += 1
})

const handleTypeSelect = (layer, index) => {
	currentDisplayLayer.value = layer
	currentDisplayLayerIndex.value = index
}
</script>
